<template>
  <tr :class="{ 'boss-table-4-selected': isCurrentPhase }">
    <td data-test="phase-name">
      <div class="pega-md-radio">
        <input
          :id="`phase-${selection.phase.id}`"
          :value="selection.phase.id"
          :checked="isCurrentPhase"
          type="radio"
          @change="updateSelectionPhase($event.target._value)"
        >
        <label
          :for="`phase-${selection.phase.id}`"
          class="pega-input"
        >{{ phaseName }}</label>
      </div>
    </td>
    <td data-test="status">
      <select
        v-model="statusId"
        data-test="select-statuses"
        class="boss-input-select"
        @change="updateStatus"
      >
        <option :value="null">
          ー
        </option>
        <option
          v-for="(status, j) in allStatuses"
          :key="j"
          :data-test="'status-' + j"
          :value="status.id"
        >
          {{ status.name }}
        </option>
      </select>
    </td>
    <td
      v-if="selection.isEntryPhase"
      data-test="start-date-label"
    >
      {{ startDate | dateLabel }}
    </td>
    <td
      v-else
      class="pega-picker-td"
    >
      <date-picker
        v-model="date"
        :minute-step="10"
        type="date"
        input-class="pega-picker"
        :style="{ width: 'auto' }"
        placeholder="日付を選択"
        value-type="YYYY-MM-DDTHH:mm"
        :editable="false"
        @change="updateDateTime"
        @clear="clearDateTime"
      />
      <date-picker
        v-model="times"
        :minute-step="10"
        :disabled-time="notNightTime"
        :default-value="defaultValueInDaytime"
        type="time"
        popup-class="pega-custom-time-header"
        placeholder="時間を選択"
        range
        format="HH:mm"
        input-class="pega-picker"
        :popup-style="{ width: '300px' }"
        :style="{ width: 'auto' }"
        value-type="YYYY-MM-DDTHH:mm"
        :editable="false"
        @close="updateDateTime"
        @clear="clearDateTime"
      >
        <template #header>
          <div class="mx-range-wrapper mx-btn-text pega-time-header">
            <div class="mx-time">
              <div
                class="text-center"
              >
                時：分
              </div>
            </div>
            <div class="mx-time">
              <div
                class="text-center"
              >
                時：分
              </div>
            </div>
          </div>
        </template>
      </date-picker>
      <template v-if="selection.isEditRemind">
        <template v-if="isRemindSent">
          <label
            class="display-inline boss-annotation-text"
            data-test="remind-sent"
          >※送信済み</label>
        </template>
        <template v-else-if="isRemindPeriod">
          <label class="pega-badge-radio">
            <input
              v-model="isRemind"
              data-test="is-remind-true"
              type="radio"
              :value="true"
              @change="updateIsRemind"
            >
            <span class="pega-badge-radio-text pega-badge-radio-check-mark">
              前日にリマインドメールを送る
            </span>
          </label>
          <label class="pega-badge-radio">
            <input
              v-model="isRemind"
              data-test="is-remind-false"
              type="radio"
              :value="false"
              @change="updateIsRemind"
            >
            <span class="pega-badge-radio-text pega-badge-radio-check-mark">
              送らない
            </span>
          </label>
        </template>
      </template>
    </td>
    <td>
      <select
        v-model="evaluationId"
        data-test="select-evaluations"
        class="boss-input-select"
        @change="updateEvaluation"
      >
        <option :value="null">
          ー
        </option>
        <option
          v-for="(evaluation, j) in evaluationMaster"
          :key="j"
          :data-test="'evaluation-' + j"
          :value="evaluation.id"
        >
          {{ evaluation.name }}
        </option>
      </select>
    </td>
    <td>
      <textarea
        :value="evaluationComment"
        data-test="evaluation-comment"
        class="boss-textarea-in-table-2"
        @change="updateEvaluationComment"
      />
    </td>
  </tr>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import { now, createDate } from '@/lib/dateUtils.js'
import DatePicker from 'vue2-datepicker'
import SelectionEventBus from '@/lib/selectionEventBus'
import datePickerFunction from '@/lib/datePickerFunction.js'
import Indicator from '@/lib/indicator'

export default {
  components: {
    DatePicker
  },
  filters: {
    dateLabel (date) {
      return createDate(date)?.format('YYYY年MM月DD日 HH時mm分')
    }
  },
  mixins: [datePickerFunction],
  props: {
    entryId: {
      type: Number,
      required: true
    },
    selection: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      date: this.selection.startDate,
      times: [this.selection.startDate, this.selection.endDate],
      selectionStateType: this.selection.selectionStateType,
      isEntryPhase: this.selection.isEntryPhase,
      phaseId: this.selection.phase.id,
      phaseName: this.selection.phase.name,
      statusId: _.get(this, 'selection.status.id', null),
      evaluationId: _.get(this, 'selection.evaluation.id', null),
      evaluationComment: this.selection.evaluationComment,
      isRemind: this.selection.isRemind
    }
  },
  computed: {
    ...mapGetters('settings', [
      'responsibles',
      'allStatuses',
      'fixedStatuses'
    ]),
    ...mapGetters([
      'evaluationMaster'
    ]),
    isOverLengthEvaluationComment () {
      return this.evaluationComment.length > 500
    },
    startDate () {
      return this.concatDateAndTime(this.date, this.times[0])
    },
    endDate () {
      return this.concatDateAndTime(this.date, this.times[1])
    },
    isCurrentPhase () {
      return this.selection.selectionStateType === 2
    },
    isRemindPeriod () {
      // 前日のリマインドメールなので1日プラス
      return (this.date && _.head(this.times)) ? now().add(1, 'days').isBefore(`${createDate(this.date)?.format('YYYY-MM-DD')}`, 'days') : false
    },
    isRemindSent () {
      // 送信済み判定 バックエンドでリマインド送った情報を持っていないため、リマインドメールを送る設定かつ日時で判定
      return this.isRemind && now().isAfter(`${createDate(this.date)?.subtract(1, 'days').format('YYYY-MM-DD')} 09:00`, 'hour')
    }
  },
  watch: {
    selection: {
      handler (val) {
        this.$set(this, 'date', val.startDate)
        this.$set(this, 'times', [val.startDate, val.endDate])
        this.$set(this, 'selectionStateType', val.selectionStateType)
        this.$set(this, 'isEntryPhase', val.isEntryPhase)
        this.$set(this, 'phaseId', val.phase.id)
        this.$set(this, 'phaseName', val.phase.name)
        this.$set(this, 'statusId', _.get(val, 'status.id', null))
        this.$set(this, 'evaluationId', _.get(val, 'evaluation.id', null))
        this.$set(this, 'evaluationComment', val.evaluationComment)
        this.$set(this, 'isRemind', val.isRemind)
      }
    }
  },
  methods: {
    updateEvaluation () {
      this.$http.secured.put(`/entry/view/entries/${this.entryId}/phases/${this.phaseId}/evaluation`, { evaluationId: this.evaluationId }).then(response => {
        this.$toasted.global.success({ message: '評価を更新しました。' })
        SelectionEventBus.emitSelectionUpdate()
      })
    },
    updateEvaluationComment (e) {
      this.$set(this, 'evaluationComment', e.target.value)
      this.$http.secured.put(`/entry/view/entries/${this.entryId}/phases/${this.phaseId}/comment`, { comment: this.evaluationComment }).then(response => {
        this.$toasted.global.success({ message: '評価コメントを更新しました。' })
      })
    },
    updateStatus () {
      this.$http.secured.put(`/entry/view/entries/${this.entryId}/phases/${this.phaseId}/status`, { statusId: this.statusId }).then(response => {
        this.$toasted.global.success(
          {
            message: `選考ステータスを更新しました。${_.includes(this.fixedStatuses.map(status => status.id), this.statusId)
              ? `<br>応募者一覧では、画面右上の「${this.getFixedStatusesName(this.statusId)}」ボタンをONにした場合のみ表示されます。`
              : ''}`
          }
        )
        SelectionEventBus.emitSelectionUpdate()
      })
    },
    updateDateTime () {
      if (this.startDate && this.endDate) {
        this.$http.secured.put(`/entry/view/entries/${this.entryId}/phases/${this.phaseId}/date`, {
          startDate: this.startDate,
          endDate: this.endDate
        }).then(response => {
          this.$toasted.global.success({ message: '日時を更新しました。' })
          SelectionEventBus.emitSelectionUpdate()
        })
      }
    },
    clearDateTime () {
      this.date = null
      this.times = [null, null]
      this.$http.secured.put(`/entry/view/entries/${this.entryId}/phases/${this.phaseId}/date`, {
        startDate: null,
        endDate: null
      }).then(response => {
        this.$toasted.global.success({ message: '日時を削除しました。' })
        SelectionEventBus.emitSelectionUpdate()
      })
    },
    updateIsRemind () {
      this.$http.secured.put(`/entry/view/entries/${this.entryId}/phases/${this.phaseId}/remind_mail`, this.isRemind).then(response => {
        this.$toasted.global.success({ message: 'リマインドメール送信ステータスを更新しました。' })
      })
    },
    concatDateAndTime (date, time) {
      const dateObject = createDate(date)
      const timeObject = createDate(time)
      if (dateObject && timeObject) {
        return `${dateObject.format('YYYY-MM-DD')}T${timeObject.format('HH:mm')}`
      } else {
        return null
      }
    },
    updateSelectionPhase (id) {
      Indicator.emitShow()
      this.$http.secured.put('/entry/view/entries/phases', { entryIds: [this.entryId], itemId: id })
        .then(response => {
          this.$toasted.global.success({ message: '選考フェーズを更新しました。' })
          SelectionEventBus.emitSelectionUpdate()
        }).finally(() => {
          Indicator.emitHide()
        })
    },
    getFixedStatusesName (statusId) {
      return this.fixedStatuses.find(status => _.isEqual(status.id, statusId)).name
    }
  }
}
</script>
